import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { Link, NavLink } from "react-router-dom";
import { SystemType } from "src/types/main";
import { twMerge } from "tailwind-merge";
import { MobileLogoIcon } from "./ui-icons/header";
import { SidebarMenuBtnsIcon } from "./ui-icons/sidebar";
import { CloseIcon } from "src/pages/Reports/shared/icons";

export function SystemMenuMobile({ list }: { list: SystemType[] }) {

  const skippedIds: number[] = [2, 4, 5, 6, 7];

  return (
    <Menu as="div" className="flex text-left"> 
      {({ open }) => (
        <>
          <div>
            <Menu.Button
              className={twMerge(
                open ? "button-state-active" : "",
                "flex items-center rounded-lg button-state"
              )}
            >
              <SidebarMenuBtnsIcon />
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="fixed left-0 right-0 top-0 bottom-0  z-10 origin-top-right bg-white shadow-custom ring-1 ring-black ring-opacity-5 focus:outline-none h-full">
              <Menu.Item>
                {({ close }) => (
                  <div 
                    className="flex flex-row items-center p-5 gap-x-2 cursor-pointer"
                    onClick={() => close()}
                  >
                    <CloseIcon/>
                  </div>
                )}
              </Menu.Item>
              <Menu.Item>
                <NavLink
                  to="/"
                  className="flex flex-row items-center p-5 gap-x-2 bg-[#FFFFFF] hover:bg-[#F5F7FD]"
                >
                  <div className="flex flex-col">
                    <MobileLogoIcon />
                  </div>
                </NavLink>
              </Menu.Item>
              {list
                .filter((system) => !skippedIds.includes(system.id))
                .map((system) => (
                <Menu.Item key={system.id}>
                  <Link
                    to={system.externalLink || `/dashboard/${system.id}`}
                    className="flex flex-row items-center p-5 gap-x-2 bg-[#FFFFFF] hover:bg-[#F5F7FD]"
                  >
                    <div className="flex flex-col items-end">
                      <div className="w-6 h-6">
                        <img
                          className="object-contain w-full h-full"
                          src={system.url}
                          alt={system.title}
                          srcSet={system.url}
                        />
                      </div>
                    </div>
                    <div className="flex flex-col w-5/6 font-medium">
                      {system.title}
                    </div>
                  </Link>
                </Menu.Item>
              ))}
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
}